/* eslint-disable @next/next/no-img-element */
import React from 'react';

import cx from 'classnames';

import s from './PlayfulItem.module.css';

type OverlayProps = {
  children: React.ReactNode;
};

const Overlay = ({ children }: OverlayProps) => {
  return <div className={s.overlay}>{children}</div>;
};

export interface ItemProps {
  className?: string;
  selected?: boolean;
  listView?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  title: string;
  image?: string;
  button?: React.ReactNode;
  overlay?: React.ReactNode;
}

export const Item = ({
  selected,
  disabled = false,
  listView = false,
  children,
  title,
  image,
  button,
  className,
  overlay,
}: ItemProps) => {
  return (
    <article
      className={cx(
        s.root,
        {
          [s.highlighted]: selected,
          [s.listItem]: listView,
          [s.disabled]: disabled,
        },
        className,
      )}
    >
      {image && (
        <div className={s.imageWrapper}>
          <img className={s.image} src={image} alt={title} loading="lazy" />
        </div>
      )}

      <div className={s.content}>
        <div className={s.description}>
          <h3 className={s.title}>{title}</h3>
          {children}
        </div>

        {button}
      </div>
      {overlay}
    </article>
  );
};

Item.Overlay = Overlay;
